import { render } from "./PortfolioPage.vue?vue&type=template&id=74a09c8c&scoped=true"
import script from "./PortfolioPage.vue?vue&type=script&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&lang=js"

import "./PortfolioPage.vue?vue&type=style&index=0&id=74a09c8c&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a09c8c"]])

export default __exports__